import React from 'react';
import PropTypes from 'prop-types';
import formStyles from './Form.module.scss';
import DayPickerField from './DayPickerField';
import TimeOnlyPickerField from './TimeOnlyPickerField';
import { useFormikContext } from 'formik';

const DateTimePickerField = ({ name, disabledAfter, disabledBefore }) => {
  const { values } = useFormikContext();
  const selectedDate = values[name] || null;

  return (
    <div className={formStyles.row}>
      <div className={formStyles.col}>
        <DayPickerField
          className={formStyles.InputField}
          name={name}
          disabledBefore={disabledBefore}
          disabledAfter={disabledAfter}
          placeholderText="YYY-MM-DD"
        />
      </div>
      <div className={formStyles.col}>
        <TimeOnlyPickerField
          wrapperClassName={formStyles.timepicker}
          className={formStyles.InputField}
          name={`${name}Time`}
          compareDate={selectedDate}
          placeholderText="HH:MM"
        />
      </div>
    </div>
  );
};

DateTimePickerField.propTypes = {
  name: PropTypes.string.isRequired,
  disabledAfter: PropTypes.instanceOf(Date),
  disabledBefore: PropTypes.instanceOf(Date)
};

DateTimePickerField.defaultProps = {
  disabledAfter: undefined,
  disabledBefore: undefined
};

export default DateTimePickerField;
